/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonthlyPayments
 */
export interface MonthlyPayments {
    /**
     * 
     * @type {string}
     * @memberof MonthlyPayments
     */
    month: string;
    /**
     * 
     * @type {string}
     * @memberof MonthlyPayments
     */
    label: string;
    /**
     * 
     * @type {number}
     * @memberof MonthlyPayments
     */
    claimCount: number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyPayments
     */
    carrierPaymentCents: number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyPayments
     */
    supplementPaymentCents: number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyPayments
     */
    depreciationReleaseCents: number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyPayments
     */
    mortgageReleaseCents: number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyPayments
     */
    otherPaymentCents: number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyPayments
     */
    totalPaymentsCents: number;
}

/**
 * Check if a given object implements the MonthlyPayments interface.
 */
export function instanceOfMonthlyPayments(value: object): value is MonthlyPayments {
    if (!('month' in value) || value['month'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('claimCount' in value) || value['claimCount'] === undefined) return false;
    if (!('carrierPaymentCents' in value) || value['carrierPaymentCents'] === undefined) return false;
    if (!('supplementPaymentCents' in value) || value['supplementPaymentCents'] === undefined) return false;
    if (!('depreciationReleaseCents' in value) || value['depreciationReleaseCents'] === undefined) return false;
    if (!('mortgageReleaseCents' in value) || value['mortgageReleaseCents'] === undefined) return false;
    if (!('otherPaymentCents' in value) || value['otherPaymentCents'] === undefined) return false;
    if (!('totalPaymentsCents' in value) || value['totalPaymentsCents'] === undefined) return false;
    return true;
}

export function MonthlyPaymentsFromJSON(json: any): MonthlyPayments {
    return MonthlyPaymentsFromJSONTyped(json, false);
}

export function MonthlyPaymentsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonthlyPayments {
    if (json == null) {
        return json;
    }
    return {
        
        'month': json['month'],
        'label': json['label'],
        'claimCount': json['claimCount'],
        'carrierPaymentCents': json['carrierPaymentCents'],
        'supplementPaymentCents': json['supplementPaymentCents'],
        'depreciationReleaseCents': json['depreciationReleaseCents'],
        'mortgageReleaseCents': json['mortgageReleaseCents'],
        'otherPaymentCents': json['otherPaymentCents'],
        'totalPaymentsCents': json['totalPaymentsCents'],
    };
}

export function MonthlyPaymentsToJSON(json: any): MonthlyPayments {
    return MonthlyPaymentsToJSONTyped(json, false);
}

export function MonthlyPaymentsToJSONTyped(value?: MonthlyPayments | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'month': value['month'],
        'label': value['label'],
        'claimCount': value['claimCount'],
        'carrierPaymentCents': value['carrierPaymentCents'],
        'supplementPaymentCents': value['supplementPaymentCents'],
        'depreciationReleaseCents': value['depreciationReleaseCents'],
        'mortgageReleaseCents': value['mortgageReleaseCents'],
        'otherPaymentCents': value['otherPaymentCents'],
        'totalPaymentsCents': value['totalPaymentsCents'],
    };
}

